import { DayPicker } from 'react-day-picker';
import React from 'react';
import 'react-day-picker/style.css';

// Override default RDP chevron with our existing filled chevron
const NavChevron = (props) => {
    const { size = 24, orientation = "left", className } = props;

    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
        >
            {orientation === 'up' && (
                <path fill="currentColor" d="M5 15h14l-7-8z"/>
            )}
            {orientation === 'down' && (
                <path fill="currentColor" d="m11.998 17l7-8h-14z"/>
            )}
            {orientation === 'left' && (
                <path fill="currentColor" d="M15 19V5l-8 7z"/>
            )}
            {orientation === 'right' && (
                <path fill="currentColor" d="m9 19l8-7l-8-7z"/>
            )}
        </svg>
    );
};

const DatePicker = (props) => {
    return (
        <DayPicker
            components={{
                Chevron: NavChevron,
                ...props.components,
            }}
            timeZone="Pacific/Auckland"
            {...props}
        />
    );
};

export default DatePicker;
